export const PRODUCT_TABS = [
  {
    autobotID: 'DASH_TAB_HOTELS',
    name: 'HOTELS',
    id: 'hotels',
    query: { tab: 'hotels' }
  },
  {
    autobotID: 'DASH_TAB_FLIGHTS',
    name: 'FLIGHTS',
    id: 'flights',
    query: { tab: 'flights' }
  },
  {
    autobotID: 'DASH_TAB_HOTEL + FLIGHT',
    name: 'BUNDLE + SAVE',
    id: 'vacations',
    query: { tab: 'vacations' }
  },
  {
    autobotID: 'DASH_TAB_CARS',
    name: 'CARS',
    id: 'cars',
    query: { tab: 'cars' }
  },
  {
    autobotID: 'DASH_TAB_CRUISES',
    name: 'CRUISES',
    id: 'cruises',
    query: { tab: 'cruises' }
  }
] as const

export const HEADERS = {
  hotels: {
    headingKey: 'B4960A5A2A',
    subheadKey: 'A7C8BAF8A8',
    heading: 'Save more on your next hotel',
    subhead: 'Thousands of deals made every day'
  },
  flights: {
    headingKey: 'HOMEPAGE.FLIGHTS.TAB.HEADLINE',
    subheadKey: 'HOMEPAGE.FLIGHTS.TAB.SUBHEADLINE',
    heading: 'Save more on your next flight',
    subhead: 'Thousands of deals made every day'
  },
  vacations: {
    headingKey: 'HOMEPAGE.PACKAGES.TAB.HEADLINE',
    subheadKey: 'HOMEPAGE.VP.TAB.SUBHEADLINE',
    heading: 'Save up to $625 on your hotel and flight',
    subhead: 'Book together for our best deals'
  },
  cars: {
    headingKey: 'HOMEPAGE.RENTALCARS.TAB.HEADLINE',
    subheadKey: 'HOMEPAGE.RC.TAB.SUBHEADLINE',
    heading: 'Save more on your next rental car',
    subhead: 'Thousands of deals made every day'
  },
  cruises: {
    headingKey: 'HOMEPAGE.CRUISES.TAB.HEADLINE',
    subheadKey: 'HOMEPAGE.CRUISES.TAB.SUBHEADLINE',
    heading: 'Save more on your next cruise',
    subhead: 'Thousands of deals made every day'
  }
}

export const AMENITIES = {
  AIRSHUTTL: 'Search Hotels with Airport Shuttles',
  CASINO: 'Search Hotels with Casinos',
  FBRKFST: 'Search Hotels with Free Breakfast',
  FINTRNT: 'Search Hotels with Free Internet',
  FITSPA: 'Search Hotels with Gyms',
  FPRKING: 'Search Hotels with Free Parking',
  INCLUSIVE: 'Search All Inclusive Hotels',
  KITCHEN: 'Search Hotels with Kitchens',
  PETALLOW: 'Search Pet Friendly Hotels',
  SPOOL: 'Search Hotels with Swimming Pools',
  RESTRNT: 'Search Hotels with Restaurants',
  SPA: 'Search Hotels with Spas'
} as const
